import * as React from 'react';
import { Link } from 'umi';
import styles from './index.less';

interface AOrLinkProps {
  children: any;
  href: string;
  target?: '_self' | '_blank';
  className?: string;
  style?: React.CSSProperties;

  // UmiLinkPatch?: any;
}

function AOrLink({ children, href, target, className = '', style = {} }: AOrLinkProps) {

  // const Link = UmiLinkPatch;

  return (<>
    {
      href?.startsWith('http')
        ? (<a
          className={[styles.styles, className].join(' ')}
          style={style}
          href={href}
          target={target}
        >{children}</a>)
        : (<Link
          className={[styles.styles, className].join(' ')}
          style={style}
          to={href}
          target={target}
        >{children}</Link>)
    }
  </>);
}

export default AOrLink;
